import { Component, computed, effect, EventEmitter, inject, input, InputSignal, Output, signal, untracked, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VideoPlayerService } from 'src/app/shared/audio-player/audio-player.service';

@Component({
  selector: 'select-dropdown',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})

export class SelectDropdownComponent { 
    @Output() private urlEmitter: EventEmitter<any> = new EventEmitter<any>();
    private audioPlayerService = inject(VideoPlayerService);
    public items: InputSignal<any> = input.required<any>();
    public isAudio = computed(() => this.audioPlayerService.audio());
    public isExpanded = signal(false);

    changeLang = effect(() => {
      const items = this.items();
      untracked(() => {
        this.isExpanded.set(false);
        this.audioPlayerService.isPlaying.set(false);
        this.urlEmitter.emit(null);
      })
    }, { allowSignalWrites: true })
  
    public handleClick(){
      if (this.items()?.length === 1){
        this.isExpanded.set(false);
        this.urlEmitter.emit(this.items()?.[0]?.src);
        return;
      }

      this.toggleExpand();
    }

    public toggleExpand(){
        this.isExpanded.update(prev => !prev);
    }

    public playAudio(event, src){
      event.stopPropagation();
      this.isExpanded.set(false);
      this.urlEmitter.emit(src);
    }

    public stopAudio(){
      this.isExpanded.set(false);
      this.urlEmitter.emit(null);
    }
    
}